import './map.scss';

import { GoogleMap, InfoWindow, Marker, withGoogleMap, withScriptjs } from 'react-google-maps';
import React, { Component } from 'react';

import Autocomplete from 'react-google-autocomplete';
import { GoogleMapsAPI } from './client-config';
import { LoadingOutlined } from '@ant-design/icons';
import TextComponent from '@sharedComponent/typography/TextComponent';
import { images } from 'src/assets/img';

class AtmMap extends Component {
	constructor(props) {
		super(props);
		this.state = {
			marks: [
				{
					lat: 25.410078,
					lng: 55.444283,
					atmType: null,
				},
			],
			marks2: [
				{
					lat: 25.410078,
					lng: 55.444283,
				},
			],
			showingInfoWindow: false,
			markerClick: {},
			infoData: [],
			test: false,
			c3bankData: [],
			rakbankData: [],
			switch: false,
			defaultSwitch: false,
			defaultSwitchLocation: false,
			ownPosition: [],
			count: 0,
			home: {
				lat: null,
				lng: null,
			},
			arraycordinates: [
				{
					name: 'abudhabi',
					lat: 24.483858,
					long: 54.36518,
				},
				{
					name: 'ajman',
					lat: 25.410956,
					long: 55.444054,
				},
				{ name: 'alain', lat: 24.26581, long: 55.765326 },
				{ name: 'dubai', lat: 25.134904, long: 55.23936 },
				{ name: 'fujairah', lat: 25.125124, long: 56.345153 },
				{ name: 'rasalkhaimah', lat: 25.787688, long: 55.992673 },
				{ name: 'sharjah', lat: 25.358134, long: 55.393623 },
			],
			allEmirates: false,
			locationList: false,
			dynamicZoom: 12,
		};
		this._handleKeyDown = this._handleKeyDown.bind(this);
	}

	onMarkerClick = () => {
		this.setState({
			showingInfoWindow: true,
		});
	};

	onMapClicked = (props) => {
		if (this.state.showingInfoWindow) {
			this.setState({
				showingInfoWindow: false,
				activeMarker: null,
			});
		}
	};
	_handleKeyDown(e) {
		if (e.key === 'Enter') {
			this.props.onPlaceSelected();
		}
	}

	componentDidUpdate(prevProps, nextProps) {
		if (prevProps.infoData !== this.props.infoData) {
			this.setState({ infoData: this.props.infoData, defaultSwitchLocation: nextProps.defaultSwitch, markerClick: this.props.infoData });
		}
	}

	componentWillReceiveProps(nextProps) {
		let splitedRak;
		let splitedC3;

		// You don't have to do this check first, but it can help prevent an unneeded render
		if (nextProps.atmlocationData !== this.state.atmlocationData) {
			let rakbank = nextProps.atmlocationData.filter((data) => data.atmType == 'RAKBANK');
			let c3bank = nextProps.atmlocationData.filter((data) => data.atmType == 'C3Pay');
			let coordinateRak = rakbank.map((data) => data.coordinate);
			let coordinateC3 = c3bank.map((data) => data.coordinate);
			splitedRak = coordinateRak.map((data) => data.split(','));
			splitedC3 = coordinateC3.map((data) => data.split(','));

			if (nextProps.selectedEmirate != 'allemirates' && nextProps.selectedEmirate != null) {
				c3bank = c3bank.filter((data) => data.emirate.toLowerCase().replaceAll(' ', '') == nextProps.selectedEmirate?.toLowerCase());
				rakbank = rakbank.filter((data) => data.emirate.toLowerCase().replaceAll(' ', '') == nextProps.selectedEmirate?.toLowerCase());
			} else if (nextProps.selectedEmirate == 'allemirates') {
				c3bank = nextProps.atmlocationData.filter((data) => data.atmType === 'C3Pay');
				rakbank = nextProps.atmlocationData.filter((data) => data.atmType === 'RAKBANK');
			}

			this.setState({ c3bankData: c3bank, rakbankData: rakbank, defaultSwitch: this.props.markerOff });
			splitedC3.map((data) => {
				this.setState((prevState) => ({
					marks: [...prevState.marks, { lat: parseFloat(data[0]), lng: parseFloat(data[1]) }],
				}));
			});
			splitedRak.map((data) => {
				this.setState((prevState) => ({
					marks2: [...prevState.marks2, { lat: parseFloat(data[0]), lng: parseFloat(data[1]) }],
				}));
			});

			navigator.geolocation.getCurrentPosition(
				(position) => {
					this.setState({
						home: { lat: position.coords.latitude, lng: position.coords.longitude },
					});
				},
				(error) => {
					handleRandom();
					console.warn(error.message);
				},
				{ enableHighAccuracy: false, timeout: 10000 }
			);
		}
		const handleRandom = () => {
			// this.props.setEnableLocationPromt(true);
			let locationLat = 25.410078;

			let locationLong = 55.444283;
			this.setState({
				home: { lat: locationLat, lng: locationLong },
			});
		};

		this.setState({ allEmirates: true });
		this.setState({ locationList: this.props.locationList });
		this.setState({ dynamicZoom: nextProps.selectedEmirate == 'allemirates' ? 8 : 12 });
	}

	handleC3Click = (data) => {
		let lat = data.mark?.lat;
		let lng = data.mark?.lng;
		let temp = this.props.atmlocationData.filter((data) => {
			let ra = data.coordinate.split(',');
			if (parseFloat(ra[0]) === parseFloat(lat)) {
				return data;
			}
		});

		temp = temp[0];

		this.setState({ infoData: temp, test: true });
	};
	render() {
		const AsyncMap = withScriptjs(
			withGoogleMap((props) => (
				<GoogleMap
					google={this.props.google}
					defaultZoom={
						(this.props.c3atmsIsSelected || this.props.rakatmIsSelected ? this.state.dynamicZoom : 8) ||
						(this.props.zoom && this.props.zoom)
					}
					defaultCenter={{
						lat:
							this.state.home.lat != null && !this.props.locationList && this.props.markerPosition.lat == 13.0827
								? this.state.home.lat
								: this.props.markerPosition.lat,
						lng:
							this.state.home.lng != null && !this.props.locationList && this.props.markerPosition.lng == 80.2707
								? this.state.home.lng
								: this.props.markerPosition.lng,
					}}>
					{/* InfoWindow on top of marker */}

					{this.props.nodata && (
						<>
							<Marker
								onClick={() => {
									this.setState({
										defaultSwitch: true,
									});
								}}
								google={this.props.google}
								draggable={false}
								onDragEnd={this.props.onMarkerDragEnd}
								position={{
									lat: this.state.home.lat,
									lng: this.state.home.lng,
								}}
								origin={new window.google.maps.Point(0, 0)}
							/>
							{this.state.defaultSwitch && (
								<InfoWindow
									onClose={this.onMapClicked}
									position={{
										lat: this.state.home.lat + 0.0156,
										lng: this.state.home.lng,
									}}>
									<div>
										<TextComponent className="atm-address">My location</TextComponent>
									</div>
								</InfoWindow>
							)}
							<Marker />{' '}
						</>
					)}

					{this.state.defaultSwitchLocation && this.props.nodata && (
						<>
							{' '}
							<Marker
								onClick={() => {
									let mark = {
										lat: this.props.markerPosition.lat,
										lng: this.props.markerPosition.lng,
									};
									this.setState({
										markerClick: {
											mark,
										},
										defaultSwitchLocation: true,
									});
									this.handleC3Click(this.state.markerClick);
								}}
								google={this.props.google}
								draggable={false}
								onDragEnd={this.props.onMarkerDragEnd}
								position={{
									lat: this.props.markerPosition.lat,
									lng: this.props.markerPosition.lng,
								}}
								origin={new window.google.maps.Point(0, 0)}
								icon={{
									url: images.mappoint,

									anchor: new window.google.maps.Point(17, 46),

									scaledSize: new window.google.maps.Size(50, 50),
								}}
							/>
							{this.state.defaultSwitchLocation && this.state.infoData ? (
								<InfoWindow
									onClose={this.onMapClicked}
									options={{ pixelOffset: new window.google.maps.Size(8, -40) }}
									position={{
										lat: this.props.markerPosition.lat,
										lng: this.props.markerPosition.lng,
									}}>
									<div className="info-web">
										{this.state.infoData?.atmType == 'RAKBANK' ? (
											<img src={images.rk} alt="" className="bank-img-popup" />
										) : (
											<img src={images.c3} alt="" className="bank-img-popup" />
										)}
										<div>
											<TextComponent className="atm-address">{this.state.infoData?.name}</TextComponent>
										</div>
										<div>
											<TextComponent className="atm-area">{this.state.infoData?.emirate}</TextComponent>
										</div>
										<div>
											<TextComponent className="atm-description-map">{this.state.infoData?.location}</TextComponent>
										</div>
										<button
											className="atm-button-map"
											onClick={() => {
												let temp = this.props.markerPosition.lat + ',' + this.props.markerPosition.lng;
												temp = this.state.infoData?.name == null ? 'dubai' : temp;
												window.open(
													`http://maps.google.com/maps?saddr=+ ${
														this.state.home.lat + `,` + this.state.home.lng
													}+&daddr= + ${temp}`
												);
											}}>
											GET DIRECTIONS
										</button>
									</div>
								</InfoWindow>
							) : null}
							<Marker />{' '}
						</>
					)}
					{this.props.c3atmsIsSelected && (
						<>
							{this.state.c3bankData.map((mark, index) => {
								let temp = mark.coordinate.split(',');
								let coordinates = { lat: parseFloat(temp[0]), lng: parseFloat(temp[1]) };
								return (
									<Marker
										onClick={() => {
											this.setState({
												switch: true,
												markerClick: mark,
												defaultSwitchLocation: false,
											});
										}}
										icon={{
											url: images.mappoint,

											anchor: new window.google.maps.Point(17, 46),

											scaledSize: new window.google.maps.Size(50, 50),
										}}
										key={index}
										position={coordinates}
										google={this.props.google}
										draggable={false}
										onDragEnd={this.props.onMarkerDragEnd}>
										{mark == this.state.markerClick ? (
											<InfoWindow
												onClose={this.onMapClicked}
												position={{
													lat: coordinates[0],
													lng: coordinates[1],
												}}>
												<div className="info-web">
													{mark.atmType == 'RAKBANK' ? (
														<img src={images.rk} alt="" className="bank-img-popup" />
													) : (
														<img src={images.c3} alt="" className="bank-img-popup" />
													)}
													<div>
														<TextComponent className="atm-address">{mark.name}</TextComponent>
													</div>
													<div>
														<TextComponent className="atm-area">{mark.emirate}</TextComponent>
													</div>
													<div>
														<TextComponent className="atm-description-map">{mark.location}</TextComponent>
													</div>
													<button
														className="atm-button-map"
														onClick={() => {
															let temp = coordinates.lat + ',' + coordinates.lng;
															temp = mark?.name == null ? 'dubai' : temp;

															window.open(
																`http://maps.google.com/maps?saddr=+ ${
																	this.state.home.lat + `,` + this.state.home.lng
																}+&daddr= + ${temp}`
															);
														}}>
														GET DIRECTIONS
													</button>
												</div>
											</InfoWindow>
										) : null}
									</Marker>
								);
							})}
						</>
					)}
					{this.props.rakatmIsSelected && (
						<>
							{this.state.rakbankData.map((mark, index) => {
								let temp = mark.coordinate.split(',');
								let coordinates = { lat: parseFloat(temp[0]), lng: parseFloat(temp[1]) };
								return (
									<Marker
										onClick={() => {
											this.setState({
												switch: true,
												markerClick: mark,
												defaultSwitchLocation: false,
											});
										}}
										icon={{
											url: images.mappoint,

											anchor: new window.google.maps.Point(17, 46),

											scaledSize: new window.google.maps.Size(50, 50),
										}}
										key={index}
										position={coordinates}
										google={this.props.google}
										draggable={false}
										onDragEnd={this.props.onMarkerDragEnd}>
										{mark == this.state.markerClick && this.props.rakatmIsSelected && !this.state.defaultSwitchLocation ? (
											<InfoWindow
												onClose={this.onMapClicked}
												position={{
													lat: coordinates[0],
													lng: coordinates[1],
												}}>
												<div className="info-web">
													{mark.atmType && mark.atmType == 'RAKBANK' ? (
														<img src={images.rk} alt="" className="bank-img" />
													) : (
														<img src={images.c3} alt="" className="bank-img" />
													)}
													<div>
														<TextComponent className="atm-address">{mark.name}</TextComponent>
													</div>
													<div>
														<TextComponent className="atm-area">{mark.emirate}</TextComponent>
													</div>
													<div>
														<TextComponent className="atm-description-map">{mark.location}</TextComponent>
													</div>
													<button
														className="atm-button-map"
														onClick={() => {
															let temp = coordinates.lat + ',' + coordinates.lng;
															temp = mark?.name == null ? 'dubai' : temp;
															window.open(
																`http://maps.google.com/maps?saddr=+ ${
																	this.state.home.lat + `,` + this.state.home.lng
																}+&daddr= + ${temp}`
															);
														}}>
														GET DIRECTIONS
													</button>
												</div>
											</InfoWindow>
										) : null}
									</Marker>
								);
							})}
						</>
					)}
					{this.state.allEmirates && this.props.selectedEmirate === 'allemirates' && !this.props.locationList && (
						<>
							{this.state.arraycordinates.map((mark, index) => {
								let coordinates = { lat: mark.lat, lng: mark.long };
								return (
									<Marker
										onClick={() => {
											this.setState({
												switch: true,
												markerClick: mark,
												defaultSwitchLocation: false,
											});
										}}
										icon={{
											url: images.mappoint,

											anchor: new window.google.maps.Point(17, 46),

											scaledSize: new window.google.maps.Size(50, 50),
										}}
										key={index}
										position={coordinates}
										google={this.props.google}
										draggable={false}
										onDragEnd={this.props.onMarkerDragEnd}>
										{mark == this.state.markerClick ? (
											<InfoWindow
												onClose={this.onMapClicked}
												position={{
													lat: coordinates[0],
													lng: coordinates[1],
												}}>
												<div className="info-web">
													{mark.atmType && mark.atmType == 'RAKBANK' ? (
														<img src={images.rk} alt="" className="bank-img" />
													) : (
														<img src={images.c3} alt="" className="bank-img" />
													)}
													<div>
														<TextComponent className="atm-address">{mark.name}</TextComponent>
													</div>
													<div>
														<TextComponent className="atm-area">{mark.emirate}</TextComponent>
													</div>
													<div>
														<TextComponent className="atm-description-map">{mark.location}</TextComponent>
													</div>
													<button
														className="atm-button-map"
														onClick={() => {
															let temp = coordinates.lat + ',' + coordinates.lng;
															temp = mark?.name == null ? 'dubai' : temp;
															window.open(
																`http://maps.google.com/maps?saddr=+ ${
																	this.state.home.lat + `,` + this.state.home.lng
																}+&daddr= + ${temp}`
															);
														}}>
														GET DIRECTIONS
													</button>
												</div>
											</InfoWindow>
										) : null}
									</Marker>
								);
							})}
						</>
					)}
					{/* For Auto complete Search Box */}
					{this.props.search && (
						<Autocomplete
							style={{
								width: '100%',
								height: '40px',
								paddingLeft: '16px',
								marginTop: '69px',
								marginBottom: '20px',
								position: 'absolute',
								top: 0,
							}}
							onPlaceSelected={this.props.onPlaceSelected}
							types={['(regions)']}
							placeholder="Search"
						/>
					)}
				</GoogleMap>
			))
		);
		let map;
		if (this.props.lat !== undefined) {
			map = (
				<>
					<div>
						<AsyncMap
							googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${GoogleMapsAPI}&libraries=places`}
							loadingElement={
								<div style={{ height: `100%` }}>
									<LoadingOutlined />
								</div>
							}
							containerElement={<div style={{ height: this.props.height }} />}
							mapElement={<div style={{ height: `100%` }} />}
						/>
					</div>
					{this.props.mylocation && (
						<div className="use_my_location_container" onClick={this.props.getMyLocation}>
							<img
								style={{
									marginTop: '2px',
									width: '25px',
									height: '25px',
									cursor: 'pointer',
								}}
								src={images.location}
							/>
							<text className="locationtext">Use my current location</text>
						</div>
					)}
				</>
			);
		} else {
			map = <div style={{ height: this.props.height }} />;
		}
		return map;
	}
}
export default AtmMap;
